import { DAYS_PER_MONTH, GROWTH_INDICATORS, ageInDays, chooseWindow, measurementStats, parseDate } from './growthIndicators';

/**
 * Monta o que o card, a aba Saúde e o PDF desenham a partir das medições do
 * paciente: estatística de cada medição e, por indicador, os pontos dentro
 * da janela do gráfico. Sem React.
 */

const byDateAsc = (a, b) => (parseDate(a.measuredAt) - parseDate(b.measuredAt)) || (Number(a.id) - Number(b.id));

/** Estatística de todas as medições, da mais antiga para a mais recente. */
export const growthStatsList = (history, birthday, gender) =>
    (Array.isArray(history) ? [...history] : []).sort(byDateAsc).map((item) => measurementStats(item, birthday, gender));

/**
 * Série de um indicador: pontos com percentil calculado, janela do gráfico e
 * quantas medições ficaram fora (idade fora da curva ou sem nascimento/sexo).
 */
export const indicatorSeries = (statsList, indicator) => {
    const withValue = statsList.filter((stats) => stats.indicators[indicator.key]);
    const ok = withValue.filter((stats) => stats.indicators[indicator.key].status === 'ok');
    const points = ok.map((stats) => ({
        x: stats.ageMonths,
        y: stats.indicators[indicator.key].chartValue,
        implausible: stats.indicators[indicator.key].implausible,
    }));
    return {
        indicator,
        points,
        window: chooseWindow(indicator, points.map((point) => point.x)),
        total: withValue.length,
        outOfRange: withValue.filter((stats) => stats.indicators[indicator.key].status === 'out_of_range').length,
    };
};

/** Indicadores com ao menos uma medição, na ordem fixa das abas. */
export const indicatorsWithData = (statsList) =>
    GROWTH_INDICATORS.filter((indicator) => statsList.some((stats) => stats.indicators[indicator.key]));

/**
 * Idades (meses) das medições da assimetria craniana, para marcá-las no eixo
 * do perímetro cefálico. A ficha craniana não registra PC: só a data é usada.
 */
export const cranialAges = (cranialRecords, birthday) =>
    (Array.isArray(cranialRecords) ? cranialRecords : [])
        .map((record) => ageInDays(birthday, record.createdAt))
        .filter((days) => days != null && days >= 0)
        .map((days) => days / DAYS_PER_MONTH);
